<ng-content select="[appPrefix]" />

<time [dateTime]="timestamp"
      cllTooltip="{{ tooltip ?? (['timestamp', 'timestampSeconds'].includes(format) ? timestamp : (timestamp | appTimestamp)) }}">
    <ng-container *ngIf="format === 'timeAgo'">
        {{ timestamp | appTimeAgo }}
    </ng-container>

    <ng-container *ngIf="format === 'date'">
        {{ timestamp | appDate }}
    </ng-container>

    <ng-container *ngIf="format === 'dateShort'">
        {{ timestamp | appDateShort }}
    </ng-container>

    <ng-container *ngIf="format === 'timestamp'">
        {{ timestamp | appTimestamp }}
    </ng-container>

    <ng-container *ngIf="format === 'timestampSeconds'">
        {{ timestamp | appTimestamp:timestampSecondsFormat }}
    </ng-container>
</time>
